import styled from 'styled-components';

export const TitleText = styled.p`
    font-family: Roboto;
    font-weight: bold;
    font-size: 16px;
    margin-left: 10px;
`;
